import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import React__default, { forwardRef, useRef, useLayoutEffect, useState, Children, cloneElement, useEffect } from 'react';
import { ChevronDown, Check, Close, Info, AlertCircle, AlertTriangle } from '@yleisradio/yds-icons-react';
import styled, { css, keyframes, ThemeProvider } from 'styled-components';
import { typography, color as color$1, darkTheme, lightTheme } from '@yleisradio/yds-core';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var fails$c = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$b = fails$c;

var functionBindNative = !fails$b(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var bind = FunctionPrototype$1.bind;
var call$6 = FunctionPrototype$1.call;
var uncurryThis$c = NATIVE_BIND$1 && bind.bind(call$6, call$6);

var functionUncurryThis = NATIVE_BIND$1 ? function (fn) {
  return fn && uncurryThis$c(fn);
} : function (fn) {
  return fn && function () {
    return call$6.apply(fn, arguments);
  };
};

var uncurryThis$b = functionUncurryThis;

var toString$3 = uncurryThis$b({}.toString);
var stringSlice$1 = uncurryThis$b(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$1(toString$3(it), 8, -1);
};

var uncurryThis$a = functionUncurryThis;
var fails$a = fails$c;
var classof$2 = classofRaw$1;

var $Object$4 = Object;
var split = uncurryThis$a(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$a(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$2(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

var $TypeError$6 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw $TypeError$6("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$c =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var shared$3 = {exports: {}};

var global$b = global$c;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$b, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$b[key] = value;
  } return value;
};

var global$a = global$c;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$a[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.24.0',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.24.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible = requireObjectCoercible$2;

var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return $Object$3(requireObjectCoercible(argument));
};

var uncurryThis$9 = functionUncurryThis;
var toObject$2 = toObject$3;

var hasOwnProperty = uncurryThis$9({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$2(it), key);
};

var uncurryThis$8 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$2 = uncurryThis$8(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$2(++id + postfix, 36);
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$g = function (argument) {
  return typeof argument == 'function';
};

var global$9 = global$c;
var isCallable$f = isCallable$g;

var aFunction = function (argument) {
  return isCallable$f(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
};

var getBuiltIn$3 = getBuiltIn$4;

var engineUserAgent = getBuiltIn$3('navigator', 'userAgent') || '';

var global$8 = global$c;
var userAgent = engineUserAgent;

var process = global$8.process;
var Deno = global$8.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$9 = fails$c;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$9(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$7 = global$c;
var shared$2 = shared$3.exports;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = nativeSymbol;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$7.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$8 = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL$1 && hasOwn$9(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID$1 && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var isCallable$e = isCallable$g;

var isObject$5 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$e(it);
};

var isObject$4 = isObject$5;

var $String$3 = String;
var $TypeError$5 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$5 = function (argument) {
  if (isObject$4(argument)) return argument;
  throw $TypeError$5($String$3(argument) + ' is not an object');
};

var objectDefineProperties = {};

var fails$8 = fails$c;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var DESCRIPTORS$a = descriptors;
var fails$7 = fails$c;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$a && fails$7(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var objectDefineProperty = {};

var global$6 = global$c;
var isObject$3 = isObject$5;

var document$1 = global$6.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$3(document$1) && isObject$3(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$9 = descriptors;
var fails$6 = fails$c;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$9 && !fails$6(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var NATIVE_BIND = functionBindNative;

var call$5 = Function.prototype.call;

var functionCall = NATIVE_BIND ? call$5.bind(call$5) : function () {
  return call$5.apply(call$5, arguments);
};

var uncurryThis$7 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$7({}.isPrototypeOf);

var getBuiltIn$2 = getBuiltIn$4;
var isCallable$d = isCallable$g;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$d($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$2(it));
};

var $String$2 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$2(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$c = isCallable$g;
var tryToString = tryToString$1;

var $TypeError$4 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$c(argument)) return argument;
  throw $TypeError$4(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};

var call$4 = functionCall;
var isCallable$b = isCallable$g;
var isObject$2 = isObject$5;

var $TypeError$3 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$b(fn = input.toString) && !isObject$2(val = call$4(fn, input))) return val;
  if (isCallable$b(fn = input.valueOf) && !isObject$2(val = call$4(fn, input))) return val;
  if (pref !== 'string' && isCallable$b(fn = input.toString) && !isObject$2(val = call$4(fn, input))) return val;
  throw $TypeError$3("Can't convert object to primitive value");
};

var call$3 = functionCall;
var isObject$1 = isObject$5;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$7 = wellKnownSymbol$8;

var $TypeError$2 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$7('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$1(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$3(exoticToPrim, input, pref);
    if (!isObject$1(result) || isSymbol$1(result)) return result;
    throw $TypeError$2("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var DESCRIPTORS$8 = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$4 = anObject$5;
var toPropertyKey$1 = toPropertyKey$2;

var $TypeError$1 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$8 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$4(O);
  P = toPropertyKey$1(P);
  anObject$4(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$4(O);
  P = toPropertyKey$1(P);
  anObject$4(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$1('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$4 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$4($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var hiddenKeys$4 = {};

var uncurryThis$6 = functionUncurryThis;
var hasOwn$8 = hasOwnProperty_1;
var toIndexedObject$3 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;

var push = uncurryThis$6([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$3(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$8(hiddenKeys$3, key) && hasOwn$8(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$8(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$7 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$3 = objectDefineProperty;
var anObject$3 = anObject$5;
var toIndexedObject$2 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$7 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$3(O);
  var props = toIndexedObject$2(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$3.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$1 = getBuiltIn$4;

var html$1 = getBuiltIn$1('document', 'documentElement');

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */

var anObject$2 = anObject$5;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$2(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$6 = wellKnownSymbol$8;
var create$1 = objectCreate;
var defineProperty$5 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$6('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty$5(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var uncurryThis$5 = functionUncurryThis;
var isCallable$a = isCallable$g;
var store$1 = sharedStore;

var functionToString = uncurryThis$5(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$a(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var global$5 = global$c;
var isCallable$9 = isCallable$g;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$5.WeakMap;

var nativeWeakMap = isCallable$9(WeakMap$1) && /native code/.test(inspectSource$1(WeakMap$1));

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$6 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;

var createNonEnumerableProperty$4 = DESCRIPTORS$6 ? function (object, key, value) {
  return definePropertyModule$2.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$4 = global$c;
var uncurryThis$4 = functionUncurryThis;
var isObject = isObject$5;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$7 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$4.TypeError;
var WeakMap = global$4.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis$4(store.get);
  var wmhas = uncurryThis$4(store.has);
  var wmset = uncurryThis$4(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$7(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$7(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$7(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var DESCRIPTORS$5 = descriptors;
var call$2 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;
var toIndexedObject$1 = toIndexedObject$5;
var toPropertyKey = toPropertyKey$2;
var hasOwn$6 = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$5 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$6(O, P)) return createPropertyDescriptor$1(!call$2(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$4 = descriptors;
var hasOwn$5 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$4 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$5(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$4 || (DESCRIPTORS$4 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var fails$5 = fails$c;
var isCallable$8 = isCallable$g;
var hasOwn$4 = hasOwnProperty_1;
var DESCRIPTORS$3 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$2;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$1 = InternalStateModule$1.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$3 && !fails$5(function () {
  return defineProperty$4(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$4(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$3) defineProperty$4(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$4(options, 'arity') && value.length !== options.arity) {
    defineProperty$4(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$4(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$3) defineProperty$4(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$4(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$8(this) && getInternalState$1(this).source || inspectSource(this);
}, 'toString');

var isCallable$7 = isCallable$g;
var definePropertyModule$1 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$3 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$7(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$1.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$4;
var uncurryThis$3 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$1 = anObject$5;

var concat$1 = uncurryThis$3([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$1(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$4 = fails$c;
var isCallable$6 = isCallable$g;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$6(detection) ? fails$4(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$3 = global$c;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var defineBuiltIn$2 = defineBuiltIn$3;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$3;
  } else if (STATIC) {
    target = global$3[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$3[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    defineBuiltIn$2(target, key, sourceProperty, options);
  }
};

var fails$3 = fails$c;

var correctPrototypeGetter = !fails$3(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$2 = hasOwnProperty_1;
var isCallable$5 = isCallable$g;
var toObject$1 = toObject$3;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$5(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$2 = fails$c;
var isCallable$4 = isCallable$g;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$1 = defineBuiltIn$3;
var wellKnownSymbol$5 = wellKnownSymbol$8;

var ITERATOR$2 = wellKnownSymbol$5('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es-x/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$2(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$2].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$4(IteratorPrototype$2[ITERATOR$2])) {
  defineBuiltIn$1(IteratorPrototype$2, ITERATOR$2, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$3 = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$4 = wellKnownSymbol$8;

var TO_STRING_TAG$3 = wellKnownSymbol$4('toStringTag');

var setToStringTag$2 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$1(target, TO_STRING_TAG$3)) {
    defineProperty$3(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$2;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isCallable$3 = isCallable$g;

var $String$1 = String;
var $TypeError = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$3(argument)) return argument;
  throw $TypeError("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$2 = functionUncurryThis;
var anObject = anObject$5;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$2(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$3 = _export;
var call$1 = functionCall;
var FunctionName = functionName;
var isCallable$2 = isCallable$g;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var defineBuiltIn = defineBuiltIn$3;
var wellKnownSymbol$3 = wellKnownSymbol$8;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$3('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$2(CurrentIteratorPrototype[ITERATOR$1])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$1(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$3({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$1, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty$2 = objectDefineProperty.f;
var defineIterator = defineIterator$1;
var DESCRIPTORS$2 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$2 && values.name !== 'values') try {
  defineProperty$2(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$2 = global$c;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var wellKnownSymbol$2 = wellKnownSymbol$8;

var ITERATOR = wellKnownSymbol$2('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$2('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$2[COLLECTION_NAME] && global$2[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var DESCRIPTORS$1 = descriptors;
var uncurryThis$1 = functionUncurryThis;
var call = functionCall;
var fails$1 = fails$c;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$3;
var IndexedObject = indexedObject;

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty$1 = Object.defineProperty;
var concat = uncurryThis$1([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$1(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$2 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$$2({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const MenuBase = /*#__PURE__*/styled.ul.withConfig({
  displayName: "Menustyles__MenuBase",
  componentId: "sc-1ww20n3-0"
})(["position:absolute;background-color:", ";box-shadow:0px 0px 16px rgba(0,0,0,0.15);border-radius:8px;padding:8px 0;margin:0;list-style-type:none;z-index:1000;min-width:", ";transform:translateX(-100%);outline:0;"], ({
  theme
}) => theme.BACKGROUND_DIALOG, ({
  minWidth
}) => `${minWidth}px`);
const MenuBackdrop = /*#__PURE__*/styled.div.withConfig({
  displayName: "Menustyles__MenuBackdrop",
  componentId: "sc-1ww20n3-1"
})(["position:fixed;top:0;left:0;bottom:0;right:0;z-index:999;"]);

const mergeRefs = (...refs) => {
  return node => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref !== null) {
        ref.current = node;
      }
    }
  };
};

const WINDOW_MARGIN = 12;

const getNextItem = (list, current) => {
  if (list === current) {
    return list.firstElementChild;
  } else if (current && current.nextElementSibling) {
    return current.nextElementSibling;
  } else {
    return list.firstElementChild;
  }
};

const getPreviousItem = (list, current) => {
  if (list === current) {
    return list.lastElementChild;
  } else if (current && current.previousElementSibling) {
    return current.previousElementSibling;
  } else {
    return list.lastElementChild;
  }
};

const navigate = (list, current, navigateFn) => {
  let didWrap = false;
  let next = navigateFn(list, current);

  while (next !== null) {
    if (next === list.firstElementChild) {
      if (didWrap) {
        return;
      }

      didWrap = true;
    }

    if (next.hasAttribute('tabindex')) {
      next.focus();
      return;
    } else {
      next = navigateFn(list, next);
    }
  }
};

const MenuList = /*#__PURE__*/forwardRef(({
  id,
  close,
  rootElement,
  autofocus,
  children
}, ref) => {
  const menuListRef = useRef(null);
  const mergedRef = mergeRefs(menuListRef, ref);
  useLayoutEffect(() => {
    const elem = menuListRef.current;

    if (elem === null) {
      console.log('MenuList element has not been rendered');
      return;
    }

    const container = rootElement.ownerDocument.defaultView;

    if (container === null) {
      console.log('MenuList container is not a window');
      return;
    }

    const setPosition = (top, left) => {
      elem.style.top = `${top}px`;
      elem.style.left = `${left}px`;
    };

    const top = rootElement.offsetTop + rootElement.offsetHeight;
    const left = rootElement.offsetLeft + rootElement.offsetWidth;
    setPosition(top, left);
    const elemRect = elem.getBoundingClientRect();
    const bottomMax = container.innerHeight - WINDOW_MARGIN;
    const leftMin = WINDOW_MARGIN;
    const bottomOverflow = Math.max(0, elemRect.bottom - bottomMax);
    const leftUnderflow = Math.max(0, leftMin - elemRect.left);
    setPosition(top - bottomOverflow, left + leftUnderflow);

    if (autofocus) {
      const firstChild = elem.firstElementChild;

      if (firstChild && firstChild instanceof HTMLElement) {
        firstChild.focus();
      }
    }
  }, [rootElement, autofocus]);

  const onKeyDown = e => {
    const list = menuListRef.current;

    if (list === null) {
      return;
    }

    const current = list.ownerDocument.activeElement;
    const {
      key
    } = e;

    if (key === 'ArrowDown') {
      e.preventDefault();
      navigate(list, current, getNextItem);
    } else if (key === 'ArrowUp') {
      e.preventDefault();
      navigate(list, current, getPreviousItem);
    } else if (key === 'Escape') {
      e.preventDefault();
      rootElement.focus();
      close();
    }
  };

  return jsx(MenuBase, Object.assign({
    id: id,
    onKeyDown: onKeyDown,
    ref: mergedRef,
    minWidth: Math.max(150, rootElement.offsetWidth),
    tabIndex: -1,
    role: "menu"
  }, {
    children: children
  }));
});
const Menu = /*#__PURE__*/forwardRef(({
  id,
  rootElement,
  autofocus,
  close,
  children
}, ref) => {
  if (rootElement) {
    return jsxs(Fragment, {
      children: [jsx(MenuBackdrop, {
        onClick: close,
        "aria-hidden": "true"
      }), jsx(MenuList, Object.assign({
        ref: ref,
        id: id,
        close: close,
        rootElement: rootElement,
        autofocus: autofocus
      }, {
        children: children
      }))]
    });
  }

  return null;
});

const ButtonBase = /*#__PURE__*/styled.button.withConfig({
  displayName: "Buttonstyles__ButtonBase",
  componentId: "sc-17sr1bx-0"
})(["display:inline-flex;position:relative;align-items:center;justify-content:center;border-radius:100px;width:", ";font-weight:700;outline:none;line-height:1.5;font-family:'Open Sans',sans-serif;text-decoration:none;text-align:center;padding:4px 2px;min-height:32px;border:2px solid transparent;cursor:pointer;", " ", " ", " ", " ", " &:focus-visible{outline:3px solid ", ";outline-offset:2px;}", ""], props => props.fullWidth ? '100%' : 'auto', props => props.size === 'xs' && css(["padding-left:10px;padding-right:10px;min-height:32px;min-width:32px;font-size:12px;"]), props => props.size === 'sm' && css(["padding-left:14px;padding-right:14px;min-height:40px;min-width:40px;font-size:12px;"]), props => props.size === 'md' && css(["padding-left:16px;padding-right:16px;min-height:48px;min-width:48px;font-size:14px;"]), props => props.size === 'lg' && css(["padding-left:24px;padding-right:24px;min-height:56px;min-width:56px;font-size:18px;"]), props => props.iconOnly && css(["padding-left:4px;padding-right:4px;"]), props => props.theme.BORDER_PRIMARY_FOCUS, props => props.isDisabled && css(["cursor:not-allowed;"]));
const ButtonPrimary = /*#__PURE__*/styled(ButtonBase).withConfig({
  displayName: "Buttonstyles__ButtonPrimary",
  componentId: "sc-17sr1bx-1"
})(["background-color:", ";border-color:transparent;color:", ";", " ", ""], props => props.theme.ACTION_PRIMARY, props => props.theme.TEXT_NEGATIVE, props => !(props.$loading || props.isDisabled) && css(["&:active,&:hover{background-color:", ";border-color:transparent;}"], props => props.theme.ACTION_PRIMARY_VARIANT), props => props.isDisabled && css(["color:", ";background-color:", ";border-color:transparent;"], props => props.theme.TEXT_DISABLED, props => props.theme.ACTION_DISABLED));
const ButtonSecondary = /*#__PURE__*/styled(ButtonBase).withConfig({
  displayName: "Buttonstyles__ButtonSecondary",
  componentId: "sc-17sr1bx-2"
})(["background-color:transparent;border-color:", ";color:", ";", " ", ""], props => props.theme.ACTION_PRIMARY, props => props.theme.TEXT_DEFAULT, props => !(props.$loading || props.isDisabled) && css(["&:active,&:hover{background-color:", ";border-color:", ";}"], props => props.theme.ACTION_SECONDARY_VARIANT, props => props.theme.ACTION_PRIMARY), props => props.isDisabled && css(["color:", ";background-color:transparent;border-color:", ";"], props => props.theme.TEXT_DISABLED, props => props.theme.ACTION_DISABLED));
const ButtonText = /*#__PURE__*/styled(ButtonBase).withConfig({
  displayName: "Buttonstyles__ButtonText",
  componentId: "sc-17sr1bx-3"
})(["background-color:transparent;border-color:transparent;color:", ";", " ", " ", ""], props => props.theme.TEXT_DEFAULT, props => props.removePadding && css(["padding-left:0;padding-right:0;border-radius:8px;"]), props => !(props.$loading || props.isDisabled || props.removePadding) && css(["&:active,&:hover{background-color:", ";border-color:transparent;}"], props => props.theme.ACTION_SECONDARY_VARIANT), props => props.isDisabled && css(["color:", ";background-color:transparent;border-color:transparent;&:active,&:hover{background:transparent;border-color:transparent;}"], props => props.theme.TEXT_DISABLED));
const iconSize = /*#__PURE__*/styled.span.withConfig({
  displayName: "Buttonstyles__iconSize",
  componentId: "sc-17sr1bx-4"
})(["display:inline-block;line-height:0;& svg{", " ", " ", " ", "}"], props => props.size === 'xs' && css(["width:16px;height:16px;"]), props => props.size === 'sm' && css(["width:20px;height:20px;"]), props => props.size === 'md' && css(["width:24px;height:24px;"]), props => props.size === 'lg' && css(["width:28px;height:28px;"]));
const rotate = /*#__PURE__*/keyframes(["from{transform:rotate(0);}to{transform:rotate(360deg);}"]);
const LoadingIndicator = /*#__PURE__*/styled(iconSize).withConfig({
  displayName: "Buttonstyles__LoadingIndicator",
  componentId: "sc-17sr1bx-5"
})(["position:absolute;width:100%;height:100%;display:flex;align-items:center;justify-content:center;& svg{animation:", " ease-in-out 1500ms infinite;}"], rotate);
const IconWrapper$1 = /*#__PURE__*/styled(iconSize).withConfig({
  displayName: "Buttonstyles__IconWrapper",
  componentId: "sc-17sr1bx-6"
})(["visibility:", ";"], props => props.$loading ? 'hidden' : 'visible');
const TextWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "Buttonstyles__TextWrapper",
  componentId: "sc-17sr1bx-7"
})(["display:", ";visibility:", ";padding-left:", ";padding-right:", ";", " ", ""], props => props.iconOnly ? 'none' : 'block', props => props.$loading ? 'hidden' : 'visible', props => props.size === 'xs' && !props.hasIcon ? '4px' : '8px', props => props.size === 'xs' && !props.hasIconAfter ? '4px' : '8px', props => props.variant === 'text' && props.removePadding && !props.hasIcon && css(["padding-left:0;"]), props => props.variant === 'text' && props.removePadding && !props.hasIconAfter && css(["padding-right:0;"]));

const buttonTypes = {
  primary: ButtonPrimary,
  secondary: ButtonSecondary,
  text: ButtonText
};
const Button = /*#__PURE__*/React__default.forwardRef((_a, ref) => {
  var {
    variant = 'primary',
    isDisabled = false,
    iconBefore = undefined,
    iconAfter = undefined,
    iconOnly = false,
    loading = false,
    size = 'md',
    text,
    accessibleText,
    children,
    fullWidth = false,
    removePadding = false
  } = _a,
      other = __rest(_a, ["variant", "isDisabled", "iconBefore", "iconAfter", "iconOnly", "loading", "size", "text", "accessibleText", "children", "fullWidth", "removePadding"]);

  const StyledButton = buttonTypes[variant];
  return jsxs(StyledButton, Object.assign({
    size: size,
    fullWidth: fullWidth,
    iconOnly: iconBefore && !iconAfter || !iconBefore && iconAfter ? iconOnly : false,
    "aria-label": accessibleText ? accessibleText : text,
    isDisabled: isDisabled,
    "aria-disabled": isDisabled || loading,
    "$loading": loading,
    removePadding: removePadding,
    ref: ref
  }, other, {
    children: [!!iconBefore && jsx(IconWrapper$1, Object.assign({
      size: size,
      "$loading": loading,
      className: "yds-button__icon"
    }, {
      children: iconBefore
    })), children !== undefined && jsx(TextWrapper, Object.assign({
      hasIcon: !!iconBefore,
      hasIconAfter: !!iconAfter,
      "$loading": loading,
      isDisabled: isDisabled,
      size: size,
      variant: variant,
      removePadding: removePadding,
      className: "yds-button__content"
    }, {
      children: children
    })), text && text !== '' && jsx(TextWrapper, Object.assign({
      iconOnly: iconOnly && !!iconBefore,
      hasIcon: !!iconBefore,
      hasIconAfter: !!iconAfter,
      "$loading": loading,
      isDisabled: isDisabled,
      size: size,
      variant: variant,
      removePadding: removePadding,
      className: "yds-button__text"
    }, {
      children: text
    })), !!iconAfter && jsx(IconWrapper$1, Object.assign({
      size: size,
      "$loading": loading,
      className: "yds-button__icon"
    }, {
      children: iconAfter
    })), loading && jsx(LoadingIndicator, Object.assign({
      size: size
    }, {
      children: jsx("svg", Object.assign({
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, {
        children: jsx("path", {
          d: "M22.5 12C22.5 10.0222 21.9135 8.08879 20.8147 6.4443C19.7159 4.79981 18.1541 3.51808 16.3268 2.7612C14.4996 2.00433 12.4889 1.80629 10.5491 2.19215C8.60929 2.578 6.82746 3.53041 5.42893 4.92893C4.03041 6.32746 3.078 8.10929 2.69215 10.0491C2.30629 11.9889 2.50433 13.9996 3.26121 15.8268C4.01808 17.6541 5.29981 19.2159 6.9443 20.3147C8.58879 21.4135 10.5222 22 12.5 22",
          stroke: "currentColor",
          strokeWidth: "4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      }))
    }))]
  }));
});

const ActionMenu = _a => {
  var {
    text,
    id,
    menuId,
    children,
    variant = 'text',
    dropdown = true,
    fullWidth = false
  } = _a,
      buttonProps = __rest(_a, ["text", "id", "menuId", "children", "variant", "dropdown", "fullWidth"]);

  const [menu, setMenu] = useState(null);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const closeMenu = () => {
    var _a;

    setMenu(null);
    (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  };

  const newChildren = Children.map(children, child => {
    if (! /*#__PURE__*/React__default.isValidElement(child)) {
      return;
    }

    const originalOnClick = child.props.onClick;
    return /*#__PURE__*/cloneElement(child, {
      onClick: () => {
        originalOnClick === null || originalOnClick === void 0 ? void 0 : originalOnClick();
        closeMenu();
      }
    });
  });
  return jsxs(Fragment, {
    children: [jsx(Button, Object.assign({
      ref: buttonRef,
      variant: variant,
      iconAfter: dropdown ? jsx(ChevronDown, {}) : undefined,
      text: text,
      id: id,
      fullWidth: fullWidth
    }, buttonProps, {
      onClick: e => {
        const buttonElement = e.currentTarget;
        setMenu(menu => menu ? null : {
          root: buttonElement,
          autofocus: false
        });
      },
      onKeyDown: e => {
        if (menu && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          setMenu(null);
        } else if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setMenu({
            root: e.currentTarget,
            autofocus: true
          });

          if (menu && menuRef.current) {
            const firstChild = menuRef.current.firstElementChild;

            if (firstChild && firstChild instanceof HTMLElement) {
              firstChild.focus();
            }
          }
        }
      },
      "aria-haspopup": "true",
      "aria-controls": menu ? menuId : undefined,
      "aria-expanded": menu ? 'true' : undefined
    })), jsx(Menu, Object.assign({
      ref: menuRef,
      id: menuId,
      close: closeMenu,
      rootElement: menu && menu.root,
      autofocus: (menu === null || menu === void 0 ? void 0 : menu.autofocus) || false
    }, {
      children: newChildren
    }))]
  });
};

const CheckboxBase = /*#__PURE__*/styled.input.withConfig({
  displayName: "Checkboxstyles__CheckboxBase",
  componentId: "sc-24xsit-0"
})(({
  theme
}) => css(["appearance:none;background-color:", ";border:2px solid ", ";border-radius:4px;width:24px;height:24px;cursor:pointer;margin:0;vertical-align:bottom;margin-right:8px;&:disabled{cursor:not-allowed;background-color:transparent;border-color:", ";}&:focus{outline:none;box-shadow:0px 0px 0px 2px ", ",0px 0px 0px 4px ", ";}@supports selector(:focus-visible){&:focus{box-shadow:none;}&:focus-visible{outline:none;box-shadow:0px 0px 0px 2px ", ",0px 0px 0px 4px ", ";}}&:checked{background-color:", ";border-color:transparent;}&:checked:disabled{background-color:", ";border-color:transparent;}&:checked::after{content:'';background-color:", ";mask-image:url(\"data:image/svg+xml,%3Csvg width='14' height='11' viewBox='0 0 14 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.1583 2.82463C13.6139 2.36902 13.6139 1.63033 13.1583 1.17472C12.7027 0.719106 11.964 0.719104 11.5084 1.17472L5 7.68309L2.49162 5.17472C2.03601 4.7191 1.29732 4.7191 0.841709 5.17472C0.386097 5.63033 0.386097 6.36902 0.841709 6.82463L4.17504 10.158C4.63065 10.6136 5.36935 10.6136 5.82496 10.158L13.1583 2.82463Z' fill='%23F8F9FA'/%3E%3C/svg%3E%0A\");mask-size:100% 100%;mask-repeat:no-repeat;transform:scale(0.75,0.75);width:100%;height:100%;display:inline-block;}&:checked:disabled::after{background-color:", ";}"], theme.BACKGROUND, theme.ACTION_PRIMARY, theme.BACKGROUND_CONTROL_DISABLED, theme.BACKGROUND, theme.ACTION_PRIMARY, theme.BACKGROUND, theme.ACTION_PRIMARY, theme.FEEDBACK_HIGHLIGHT, theme.BACKGROUND_CONTROL_DISABLED, theme.TEXT_NEGATIVE, theme.TEXT_DISABLED));
const Label$1 = /*#__PURE__*/styled.label.withConfig({
  displayName: "Checkboxstyles__Label",
  componentId: "sc-24xsit-1"
})(({
  theme,
  isDisabled
}) => ({
  lineHeight: 1.5,
  height: 24,
  fontSize: 16,
  fontFamily: "'Open Sans', sans-serif",
  cursor: 'pointer',
  color: isDisabled ? theme.TEXT_DISABLED : theme.TEXT_DEFAULT
}));

const Checkbox = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
    isDisabled = false,
    label,
    name,
    onChange
  } = _a,
      other = __rest(_a, ["isDisabled", "label", "name", "onChange"]);

  return jsxs(Label$1, Object.assign({
    isDisabled: isDisabled
  }, {
    children: [jsx(CheckboxBase, Object.assign({
      ref: ref,
      type: "checkbox",
      disabled: isDisabled,
      name: name,
      "aria-disabled": isDisabled,
      onChange: onChange
    }, other)), label]
  }));
});

const RadioGroupContext = /*#__PURE__*/React__default.createContext(undefined);

function useRadioGroup() {
  return React__default.useContext(RadioGroupContext);
}

const RadioBase = /*#__PURE__*/styled.input.withConfig({
  displayName: "Radiostyles__RadioBase",
  componentId: "sc-nv3ycr-0"
})(({
  theme,
  variant,
  error
}) => css(["appearance:none;background-color:", ";border:2px solid ", ";border-radius:50%;width:24px;height:24px;cursor:pointer;margin:0;margin-right:8px;vertical-align:bottom;position:relative;&:disabled{cursor:not-allowed;background-color:transparent;border-color:", ";}&:focus{outline:none;box-shadow:0px 0px 0px 2px ", ",0px 0px 0px 4px ", ";}@supports selector(:focus-visible){&:focus{box-shadow:none;}&:focus-visible{outline:none;box-shadow:0px 0px 0px 2px ", ",0px 0px 0px 4px ", ";}}&::after{content:'';background-color:", ";border-radius:50%;width:0;height:0;opacity:0;display:inline-block;top:50%;left:50%;transform:translate(-50%,-50%);position:absolute;transition:all 250ms ease-in;}&:checked::after{width:12px;height:12px;opacity:1;}&:checked:disabled{border-color:", ";&::after{background-color:", ";}}", ""], theme.BACKGROUND, theme.ACTION_PRIMARY, theme.BACKGROUND_CONTROL_DISABLED, theme.BACKGROUND, theme.FEEDBACK_HIGHLIGHT, theme.BACKGROUND, theme.FEEDBACK_HIGHLIGHT, variant === 'secondary' ? theme.FEEDBACK_HIGHLIGHT : theme.ACTION_PRIMARY, theme.TEXT_DISABLED, theme.TEXT_DISABLED, error && css(["border-color:", ";&::after{background-color:", ";}"], theme.FEEDBACK_ERROR, theme.FEEDBACK_ERROR)));
const Label = /*#__PURE__*/styled.label.withConfig({
  displayName: "Radiostyles__Label",
  componentId: "sc-nv3ycr-1"
})(({
  theme,
  isDisabled
}) => ({
  lineHeight: 1.5,
  height: 24,
  fontSize: 16,
  fontFfamily: "'Open Sans', sans-serif",
  cursor: 'pointer',
  color: isDisabled ? theme.TEXT_DISABLED : theme.TEXT_DEFAULT
}));

const Radio = /*#__PURE__*/React__default.forwardRef((_a, ref) => {
  var {
    variant = 'primary',
    isDisabled = false,
    error: errorProp,
    label,
    name: nameProp,
    value,
    checked: checkedProp,
    onChange: onChangeProp
  } = _a,
      rest = __rest(_a, ["variant", "isDisabled", "error", "label", "name", "value", "checked", "onChange"]);

  const radioGroup = useRadioGroup();
  let onChange = onChangeProp;
  let checked = checkedProp;
  let name = nameProp;
  let error = errorProp;
  let errorId;
  let descId;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === value;
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }

    if (typeof onChangeProp === 'undefined') {
      onChange = radioGroup.onChange;
    }

    error = radioGroup.error;
    errorId = radioGroup.errorId;
    descId = radioGroup.descId;
  }

  return jsxs(Label, Object.assign({
    isDisabled: isDisabled
  }, {
    children: [jsx(RadioBase, Object.assign({
      ref: ref,
      type: "radio",
      disabled: isDisabled,
      name: name,
      "aria-disabled": isDisabled,
      "aria-describedby": [descId, errorId].filter(Boolean).join(' ') || undefined,
      variant: variant,
      error: error,
      checked: checked,
      value: value,
      onChange: onChange
    }, rest)), label]
  }));
});

const getStatusColor = ({
  theme,
  status
}) => {
  switch (status) {
    case 'success':
      return theme.FEEDBACK_SUCCESS;

    case 'error':
      return theme.FEEDBACK_ERROR;

    default:
      return theme.TEXT_DEFAULT;
  }
};

const ChoiceButtonRadio = /*#__PURE__*/styled(Radio).withConfig({
  displayName: "ChoiceButtonstyles__ChoiceButtonRadio",
  componentId: "sc-1nirp3w-0"
})(() => ({
  '&:focus-visible': {
    boxShadow: 'none'
  },
  '&:focus': {
    boxShadow: 'none'
  }
}));
const ChoiceButtonContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ChoiceButtonstyles__ChoiceButtonContainer",
  componentId: "sc-1nirp3w-1"
})(({
  theme,
  status
}) => ({
  overflow: 'hidden',
  fontFamily: "'Open Sans', sans-serif",
  fontWeight: 400,
  fontSize: 16,
  backgroundColor: theme.BACKGROUND_INTERACTIVE,
  borderRadius: 8,
  position: 'relative',

  /* HACK: Using the after pseudoelement to draw borders inside the
   * container. This would simpler with outline: -2px, but safari does
   * not support rounded corners for outline. If the issue has been fixed
   * in safari, you could consider using outline instead.
   * Issue: https://bugs.webkit.org/show_bug.cgi?id=20807 */
  '&::after': status ? {
    borderRadius: 8,
    boxShadow: 'inset 0px 0px 0px 2px ' + getStatusColor({
      theme,
      status
    }),
    content: '""',
    display: 'block',
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    pointerEvents: 'none'
  } : {},
  '&:focus-within': {
    outline: '3px solid',
    outlineColor: theme.BORDER_PRIMARY_FOCUS
  },
  outlineOffset: 2
}));
const ChoiceButtonHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "ChoiceButtonstyles__ChoiceButtonHeader",
  componentId: "sc-1nirp3w-2"
})(() => ({
  display: 'flex',
  alignItems: 'center',
  margin: '12px 16px'
}));
const ChoiceButtonIconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ChoiceButtonstyles__ChoiceButtonIconContainer",
  componentId: "sc-1nirp3w-3"
})(({
  theme,
  status
}) => ({
  marginLeft: 'auto',
  color: getStatusColor({
    theme,
    status
  }),
  '> svg': {
    verticalAlign: 'middle'
  }
}));

const ChoiceButton = /*#__PURE__*/React__default.forwardRef((_a, ref) => {
  var {
    status = undefined,
    icon,
    content
  } = _a,
      args = __rest(_a, ["status", "icon", "content"]);

  return jsxs(ChoiceButtonContainer, Object.assign({
    status: status
  }, {
    children: [jsxs(ChoiceButtonHeader, {
      children: [jsx(ChoiceButtonRadio, Object.assign({
        ref: ref
      }, args)), jsx(ChoiceButtonIconContainer, Object.assign({
        status: status
      }, {
        children: icon
      }))]
    }), jsx("div", {
      children: content
    })]
  }));
});

const MenuItemBase = /*#__PURE__*/styled.li.withConfig({
  displayName: "MenuItemstyles__MenuItemBase",
  componentId: "sc-w44mez-0"
})(["padding:12px;cursor:", ";font-family:'Open Sans';font-size:14px;line-height:24px;color:", ";background-color:", ";outline-color:", ";display:flex;flex-flow:row nowrap;&:hover{background-color:", ";}"], ({
  isDisabled
}) => isDisabled ? 'not-allowed' : 'pointer', ({
  isDisabled,
  theme
}) => isDisabled ? theme.TEXT_DISABLED : theme.TEXT_DEFAULT, ({
  theme
}) => theme.BACKGROUND_DIALOG, ({
  theme
}) => theme.FEEDBACK_HIGHLIGHT, ({
  isDisabled,
  theme
}) => isDisabled ? theme.BACKGROUND_INPUT : theme.ACTION_SECONDARY_VARIANT);
const IconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "MenuItemstyles__IconWrapper",
  componentId: "sc-w44mez-1"
})(["display:inline-block;line-height:0;width:24px;height:24px;margin-right:12px;& svg{width:24px;height:24px;", "}"], ({
  highlight,
  theme
}) => highlight ? `color: ${theme.FEEDBACK_HIGHLIGHT};` : '');

const MenuItem = _a => {
  var {
    icon,
    iconHighlight,
    isDisabled = false,
    isSelected = false,
    onClick,
    role = 'menuitem',
    children
  } = _a,
      other = __rest(_a, ["icon", "iconHighlight", "isDisabled", "isSelected", "onClick", "role", "children"]);

  const onKeyDown = e => {
    if (e.key === 'Enter' && !isDisabled) {
      e.preventDefault();
      onClick();
    }
  };

  return jsxs(MenuItemBase, Object.assign({
    onKeyDown: onKeyDown,
    isDisabled: isDisabled,
    onClick: isDisabled ? undefined : onClick,
    tabIndex: -1,
    "aria-disabled": isDisabled ? 'true' : undefined,
    "aria-selected": isSelected ? 'true' : undefined,
    role: role
  }, other, {
    children: [icon !== undefined && jsx(IconWrapper, Object.assign({
      highlight: iconHighlight
    }, {
      children: icon
    })), children]
  }));
};

const DropdownMenu = _a => {
  var _b;

  var {
    placeholder,
    value,
    options,
    onChange
  } = _a,
      menuProps = __rest(_a, ["placeholder", "value", "options", "onChange"]);

  const selectedOption = value !== undefined ? options.find(option => option.value === value) : undefined;
  return jsx(ActionMenu, Object.assign({}, menuProps, {
    text: (_b = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.text) !== null && _b !== void 0 ? _b : placeholder
  }, {
    children: options.map(option => {
      const isSelected = option.value === value;
      return jsx(MenuItem, Object.assign({
        icon: isSelected ? jsx(Check, {}) : null,
        iconHighlight: true,
        isSelected: isSelected,
        role: "menuitemradio",
        onClick: () => onChange(option.value)
      }, {
        children: option.text
      }), option.text);
    })
  }));
};

const FormElementLabelStyle = /*#__PURE__*/styled.label.withConfig({
  displayName: "FormElementLabelstyles__FormElementLabelStyle",
  componentId: "sc-ui1o3z-0"
})(({
  theme,
  hasMarginBottom,
  isDisabled
}) => css(["display:block;font-family:", ";font-weight:", ";font-size:", ";font-style:", ";line-height:", ";margin-bottom:", ";color:", ";&[for]{cursor:pointer;}"], () => typography.OPEN_SANS_S_BOLD_FONT_FAMILY, () => typography.OPEN_SANS_S_BOLD_FONT_WEIGHT, () => typography.OPEN_SANS_S_BOLD_FONT_SIZE, () => typography.OPEN_SANS_S_BOLD_FONT_STYLE, () => typography.OPEN_SANS_S_BOLD_LINE_HEIGHT, hasMarginBottom ? '8px' : '0', isDisabled ? theme.TEXT_DISABLED : theme.TEXT_DEFAULT));

const FormElementLabel = _a => {
  var {
    isDisabled = false,
    isRequired = false,
    hasMarginBottom = true,
    label = '',
    children
  } = _a,
      other = __rest(_a, ["isDisabled", "isRequired", "hasMarginBottom", "label", "children"]);

  return jsxs(FormElementLabelStyle, Object.assign({
    isDisabled: isDisabled,
    isRequired: isRequired,
    hasMarginBottom: hasMarginBottom
  }, other, {
    children: [label, children]
  }));
};

const backgroundColor$1 = ({
  variant,
  level,
  theme
}) => {
  var _a, _b;

  const backgroundColorMap = {
    info: {
      primary: theme.BACKGROUND_INFO_PRIMARY,
      secondary: theme.BACKGROUND_INFO_SECONDARY,
      text: 'transparent'
    },
    success: {
      primary: theme.BACKGROUND_SUCCESS,
      secondary: theme.BACKGROUND_SUCCESS,
      text: 'transparent'
    },
    warning: {
      primary: theme.BACKGROUND_WARNING,
      secondary: theme.BACKGROUND_WARNING,
      text: 'transparent'
    },
    error: {
      primary: theme.BACKGROUND_ERROR,
      secondary: theme.BACKGROUND_ERROR,
      text: 'transparent'
    }
  };
  return (_b = (_a = backgroundColorMap[level]) === null || _a === void 0 ? void 0 : _a[variant]) !== null && _b !== void 0 ? _b : 'transparent';
};

const getColor = ({
  theme,
  level,
  variant
}) => {
  var _a, _b;

  const colorMap = {
    info: {
      primary: color$1.GRAY_95,
      secondary: theme.TEXT_DEFAULT,
      text: theme.TEXT_DEFAULT
    },
    success: {
      primary: color$1.GRAY_95,
      secondary: color$1.GRAY_95,
      text: theme.TEXT_DEFAULT
    },
    warning: {
      primary: color$1.GRAY_95,
      secondary: color$1.GRAY_95,
      text: theme.TEXT_DEFAULT
    },
    error: {
      primary: color$1.GRAY_95,
      secondary: color$1.GRAY_95,
      text: theme.TEXT_DEFAULT
    }
  };
  return (_b = (_a = colorMap[level]) === null || _a === void 0 ? void 0 : _a[variant]) !== null && _b !== void 0 ? _b : color$1.GRAY_95;
};

const NotificationBase = /*#__PURE__*/styled.div.withConfig({
  displayName: "Notificationstyles__NotificationBase",
  componentId: "sc-1nj4haw-0"
})(({
  theme,
  level,
  variant
}) => ({
  display: 'block',
  borderRadius: 8,
  backgroundColor: backgroundColor$1({
    level,
    variant,
    theme
  }),
  fontFamily: "'Open Sans', sans-serif",
  padding: '13px 17px',
  fontSize: 14,
  fontWeight: 400,
  color: getColor({
    level,
    variant,
    theme
  })
}));
const NotificationHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "Notificationstyles__NotificationHeader",
  componentId: "sc-1nj4haw-1"
})(({
  isMultiline
}) => ({
  display: 'flex',
  flexDirection: isMultiline ? 'column' : 'row',
  flexGrow: 1,
  lineHeight: 1.5,
  paddingTop: '1px'
}));
const NotificationTitle = /*#__PURE__*/styled.div.withConfig({
  displayName: "Notificationstyles__NotificationTitle",
  componentId: "sc-1nj4haw-2"
})(() => ({
  fontWeight: 700,
  marginRight: '5px'
}));
const NotificationContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "Notificationstyles__NotificationContent",
  componentId: "sc-1nj4haw-3"
})(() => ({
  display: 'flex',
  alignItems: 'start'
}));
const NotificationText = /*#__PURE__*/styled.div.withConfig({
  displayName: "Notificationstyles__NotificationText",
  componentId: "sc-1nj4haw-4"
})(() => ({}));
const NotificationIcon = /*#__PURE__*/styled.div.withConfig({
  displayName: "Notificationstyles__NotificationIcon",
  componentId: "sc-1nj4haw-5"
})(() => ({
  marginRight: '13px',
  '& svg': {
    verticalAlign: 'middle'
  }
}));
const NotificationCloseButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "Notificationstyles__NotificationCloseButton",
  componentId: "sc-1nj4haw-6"
})(({
  theme,
  level,
  notificationVariant
}) => ({
  border: '',
  minHeight: 0,
  minWidth: 0,
  marginTop: '-2px',
  marginBottom: '-2px',
  paddingTop: '0',
  paddingBottom: '0',
  color: getColor({
    level,
    variant: notificationVariant,
    theme
  }),
  '&:focus': {
    outlineColor: notificationVariant !== 'text' ? getColor({
      level,
      variant: notificationVariant,
      theme
    }) : ''
  }
}));
const NotificationActionsContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Notificationstyles__NotificationActionsContainer",
  componentId: "sc-1nj4haw-7"
})(({
  theme,
  level,
  notificationVariant
}) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  marginTop: '30px',
  '& button:focus': {
    outlineColor: notificationVariant !== 'text' ? getColor({
      level,
      variant: notificationVariant,
      theme
    }) : ''
  }
}));

const getIcon = level => {
  switch (level) {
    case 'error':
      return jsx(AlertTriangle, {});

    case 'warning':
      return jsx(AlertCircle, {});

    case 'success':
      return jsx(Check, {});

    default:
      return jsx(Info, {});
  }
};

const Notification = _a => {
  var {
    actions,
    children,
    hideIcon,
    isMultiline,
    level = 'info',
    onClose,
    title,
    variant = 'primary'
  } = _a,
      other = __rest(_a, ["actions", "children", "hideIcon", "isMultiline", "level", "onClose", "title", "variant"]);

  return jsxs(NotificationBase, Object.assign({
    level: level,
    variant: variant
  }, other, {
    children: [jsxs(NotificationContent, {
      children: [!hideIcon && jsx(NotificationIcon, {
        children: getIcon(level)
      }), jsxs(NotificationHeader, Object.assign({
        isMultiline: isMultiline
      }, {
        children: [title && jsx(NotificationTitle, {
          children: title
        }), jsx(NotificationText, {
          children: children
        })]
      })), onClose && jsx(NotificationCloseButton, {
        level: level,
        notificationVariant: variant,
        accessibleText: "Sulje",
        onClick: onClose,
        variant: "text",
        size: "md",
        iconBefore: jsx(Close, {}),
        iconOnly: true,
        removePadding: true
      })]
    }), actions && jsx(NotificationActionsContainer, Object.assign({
      level: level,
      notificationVariant: variant
    }, {
      children: actions
    }))]
  }));
};

var wellKnownSymbol$1 = wellKnownSymbol$8;

var TO_STRING_TAG$1 = wellKnownSymbol$1('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$g;
var classofRaw = classofRaw$1;
var wellKnownSymbol = wellKnownSymbol$8;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
};

var classof = classof$1;

var $String = String;

var toString$1 = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var $$1 = _export;
var DESCRIPTORS = descriptors;
var global$1 = global$c;
var uncurryThis = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable = isCallable$g;
var isPrototypeOf = objectIsPrototypeOf;
var toString = toString$1;
var defineProperty = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$1({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const SelectFieldset = /*#__PURE__*/styled.fieldset.withConfig({
  displayName: "Selectstyles__SelectFieldset",
  componentId: "sc-110zd1q-0"
})(["border:none;padding:0;margin:0;display:block;"]);
const SelectWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Selectstyles__SelectWrapper",
  componentId: "sc-110zd1q-1"
})(["position:relative;min-width:150px;border-radius:8px;&::after{content:'';position:absolute;right:12px;top:12px;width:24px;height:24px;mask-image:url('https://design-system.cdn.yle.fi/icons/yle-icons.svg#chevron-down');mask-size:100% 100%;background-color:", ";pointer-events:none;}"], props => props.isDisabled ? props.theme.TEXT_DISABLED : props.theme.TEXT_DEFAULT);

const determineBorderColor$1 = defaultValue => props => {
  if (props.error) {
    return props.theme.FEEDBACK_ERROR;
  } else if (props.success) {
    return props.theme.FEEDBACK_SUCCESS;
  } else {
    return defaultValue;
  }
};

const SelectElement = /*#__PURE__*/styled.select.withConfig({
  displayName: "Selectstyles__SelectElement",
  componentId: "sc-110zd1q-2"
})(["appearance:none;padding:4px 40px 4px 16px;font-family:'Open Sans',sans-serif;font-size:16px;margin:0;border:2px solid ", ";height:48px;width:100%;background-color:", ";outline:none;border-radius:8px;color:", ";&::-ms-expand{display:none;}&:focus,&:active{outline:", ";outline-offset:2px;}&:required:invalid{color:", ";}&:disabled{color:", ";border-color:transparent;box-shadow:none;}"], props => determineBorderColor$1(props.theme.BORDER), props => props.theme.BACKGROUND_INPUT, props => props.theme.TEXT_DEFAULT, ({
  theme
}) => `3px solid ${theme.BORDER_PRIMARY_FOCUS}`, props => props.theme.TEXT_INPUT_PLACEHOLDER, props => props.theme.TEXT_DISABLED);
const OptionElement = /*#__PURE__*/styled.option.withConfig({
  displayName: "Selectstyles__OptionElement",
  componentId: "sc-110zd1q-3"
})(["&:disabled{color:", ";}&[hidden]:disabled{}"], props => props.theme.TEXT_DISABLED);
const FormElementDescription = /*#__PURE__*/styled.p.withConfig({
  displayName: "Selectstyles__FormElementDescription",
  componentId: "sc-110zd1q-4"
})(["color:", ";font-family:'Open Sans',sans-serif;text-decoration:none;font-size:14px;line-height:150%;margin:8px 0 0 0;"], props => props.theme.TEXT_DEFAULT);
const FormElementErrorMessage = /*#__PURE__*/styled(FormElementDescription).withConfig({
  displayName: "Selectstyles__FormElementErrorMessage",
  componentId: "sc-110zd1q-5"
})(["color:", ";"], props => props.theme.FEEDBACK_ERROR);

/**
 * A native web select component with a label and optional error and description messages.
 * extra params are passed to the underlying input component as-is, except for `aria-disabled`, which
 * is controlled by `isDisabled` and `aria-labelled-by`, which is generated from `id`.
 * Dropdown option selection UI and behavior determined by browser.
 *
 * @param {SelectProps} props
 * */

const Select = /*#__PURE__*/React__default.forwardRef(({
  isDisabled: _isDisabled = false,
  success: _success = false,
  items: _items = [],
  label: _label = 'Label',
  placeholder,
  errorMessage,
  description,
  value,
  id,
  name,
  onChange
}, ref) => jsxs(SelectFieldset, {
  children: [jsx(FormElementLabel, {
    isDisabled: _isDisabled,
    isRequired: false,
    htmlFor: id,
    label: _label
  }), jsx(SelectWrapper, Object.assign({
    isDisabled: _isDisabled,
    className: "yds-select__wrapper"
  }, {
    children: jsxs(SelectElement, Object.assign({
      ref: ref,
      disabled: _isDisabled,
      required: !!placeholder,
      name: name,
      "aria-disabled": _isDisabled,
      onChange: onChange,
      success: !errorMessage && _success,
      error: Boolean(errorMessage),
      value: value ? value : placeholder ? '' : '',
      id: id
    }, {
      children: [placeholder && jsx(OptionElement, Object.assign({
        value: "",
        hidden: true
      }, {
        children: placeholder
      }), 'placeholder-value'), _items.map(item => jsx(OptionElement, Object.assign({
        value: item.value ? item.value : item.label,
        disabled: item.disabled
      }, {
        children: item.label
      }), item.value))]
    }))
  })), Boolean(errorMessage) && jsx(FormElementErrorMessage, {
    children: errorMessage
  }), Boolean(description) && jsx(FormElementDescription, {
    children: description
  })]
}));

const SwitchBase = /*#__PURE__*/styled.input.withConfig({
  displayName: "Switchstyles__SwitchBase",
  componentId: "sc-y459sv-1"
})(({
  theme
}) => css(["appearance:none;display:flex;align-items:center;height:24px;width:44px;border-radius:24px;background-color:", ";padding:3px;margin:0;cursor:pointer;transition:background-color 0.15s linear;&::before{content:'';background-color:", ";width:18px;height:18px;border-radius:19px;position:absolute;transition:transform 0.15s cubic-bezier(0.41,0,0.24,1);}&:checked{background-color:", ";}&:checked::before{transform:translateX(20px);}&:disabled{background-color:", ";}&:focus{outline:none;box-shadow:0px 0px 0px 2px ", ",0px 0px 0px 4px ", ";}@supports selector(:focus-visible){&:focus{box-shadow:none;}&:focus-visible{outline:none;box-shadow:0px 0px 0px 2px ", ",0px 0px 0px 4px ", ";}}"], theme.BACKGROUND_CONTROL, theme.TEXT_NEGATIVE, theme.FEEDBACK_HIGHLIGHT, theme.BACKGROUND_CONTROL_DISABLED, theme.BACKGROUND, theme.ACTION_PRIMARY, theme.BACKGROUND, theme.ACTION_PRIMARY));

/**
 * Switch (or Toggle, Toggle button, Toggle switch) is a on-off selection component with a label.
 * Extra params are passed to the underlying input component as-is, except for `aria-disabled`, which
 * is controlled by `isDisabled`. Label text and Switch are linked together through component `id`.
 * Switch should be used in situation when user changing the value causes instant and persistent change -
 * for on/off selections that need to be submitted separately, use `Checkbox` component.
 *
 * @param {SwitchProps} props
 * */

const Switch = /*#__PURE__*/React__default.forwardRef((_a, ref) => {
  var {
    isDisabled = false,
    label,
    name,
    onChange
  } = _a,
      other = __rest(_a, ["isDisabled", "label", "name", "onChange"]);

  const id = other.id;
  return jsxs(Fragment, {
    children: [!!label && jsx(FormElementLabel, {
      id: `${name}--label`,
      htmlFor: id,
      isDisabled: isDisabled,
      label: label
    }), jsx(SwitchBase, Object.assign({
      ref: ref,
      type: "checkbox",
      disabled: isDisabled,
      name: name,
      "aria-disabled": isDisabled,
      role: "switch",
      onChange: onChange
    }, other))]
  });
});

const backgroundColor = ({
  theme,
  variant
}) => {
  switch (variant) {
    case 'negative':
      return theme.BACKGROUND;

    case 'transparent':
      return 'transparent';

    case 'red':
      return color$1.RED_50;

    case 'purple':
      return color$1.PURPLE_50;

    default:
      return theme.ACTION_PRIMARY;
  }
};

const color = ({
  theme,
  variant
}) => {
  switch (variant) {
    case 'negative':
      return theme.TEXT_DEFAULT;

    case 'transparent':
      return theme.TEXT_DEFAULT;

    case 'red':
    case 'purple':
      return color$1.WHITE;

    default:
      return theme.TEXT_NEGATIVE;
  }
};

const font = (fontProperty, size) => {
  const fontSize = size === 'md' ? 'XS' : 'S'; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore

  return typography[`OPEN_SANS_${fontSize}_BOLD_AC_${fontProperty}`];
};

const TagBase = /*#__PURE__*/styled.span.withConfig({
  displayName: "Tagstyles__TagBase",
  componentId: "sc-13ensuq-0"
})(({
  theme,
  size,
  variant
}) => ({
  display: 'inline-block',
  backgroundColor: backgroundColor({
    theme,
    variant
  }),
  color: color({
    theme,
    variant
  }),
  fontFamily: font('FONT_FAMILY', 'md'),
  fontWeight: font('FONT_WEIGHT', 'md'),
  fontSize: '11px',
  fontStyle: font('FONT_STYLE', 'md'),
  lineHeight: size === 'sm' ? '20px' : '24px',
  letterSpacing: '0.01em',
  textTransform: 'uppercase',
  borderRadius: 4,
  padding: '0 8px'
}));

/**
 * A tag component with a text label with various presentation options.
 * Used to convey short keywords in noticeable manner.
 *
 * @param {TagProps} props
 * */

const Tag = _a => {
  var {
    size = 'md',
    variant = 'default',
    children
  } = _a,
      other = __rest(_a, ["size", "variant", "children"]);

  return jsx(TagBase, Object.assign({
    variant: variant,
    size: size
  }, other, {
    children: children
  }));
};

var $ = _export;
var $includes = arrayIncludes.includes;
var fails = fails$c;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

const TextInputFieldset = /*#__PURE__*/styled.fieldset.withConfig({
  displayName: "TextInputstyles__TextInputFieldset",
  componentId: "sc-1muz39w-0"
})(["border:none;margin:0;padding:0;"]);
const TextInputLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "TextInputstyles__TextInputLabel",
  componentId: "sc-1muz39w-1"
})(["color:", ";font-family:'Open Sans',sans-serif;text-decoration:none;font-weight:bold;font-size:14px;line-height:150%;margin-bottom:8px;display:block;"], ({
  isDisabled,
  theme
}) => isDisabled ? theme.TEXT_DISABLED : theme.TEXT_DEFAULT);

const determineInputBorder = defaultValue => props => {
  if (props.hasIcon) return 'none';

  if (props.error) {
    return `2px solid ${props.theme.FEEDBACK_ERROR}`;
  } else if (props.success) {
    return `2px solid ${props.theme.FEEDBACK_SUCCESS}`;
  } else {
    return `2px solid ${defaultValue}`;
  }
};

const StyledTextInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "TextInputstyles__StyledTextInput",
  componentId: "sc-1muz39w-2"
})(["align-items:center;background-color:", ";border:", ";border-radius:", ";color:", ";font-family:'Open Sans',sans-serif;font-size:16px;text-decoration:none;cursor:text;height:", ";outline:none;padding:16px;width:100%;&:focus,&:active{outline:", ";outline-offset:", ";position:relative;z-index:1;}&:disabled{color:", ";border:", ";cursor:default;}&::placeholder{color:", ";}&:disabled:focus,&:disabled:active{color:", ";box-shadow:none;background-color:", ";}&:disabled::placeholder{color:", ";}"], ({
  theme
}) => theme.BACKGROUND_INPUT ? theme.BACKGROUND_INPUT : 'transparent', props => determineInputBorder(props.theme.BORDER), ({
  hasIcon
}) => hasIcon ? '6px 0 0 6px' : '8px', ({
  theme
}) => theme.TEXT_DEFAULT, ({
  hasIcon
}) => hasIcon ? '44px' : '48px', ({
  theme
}) => `3px solid ${theme.BORDER_PRIMARY_FOCUS}`, ({
  hasIcon
}) => hasIcon ? '4px' : '2px', ({
  theme
}) => theme.TEXT_DISABLED, ({
  hasIcon
}) => hasIcon ? 'none' : '2px solid transparent', ({
  theme
}) => theme.TEXT_INPUT_PLACEHOLDER, ({
  theme
}) => theme.TEXT_DISABLED, ({
  theme
}) => theme.BACKGROUND_INPUT, ({
  theme
}) => theme.TEXT_DISABLED);
const TextInputDescription = /*#__PURE__*/styled.p.withConfig({
  displayName: "TextInputstyles__TextInputDescription",
  componentId: "sc-1muz39w-3"
})(["color:", ";font-family:'Open Sans',sans-serif;text-decoration:none;font-size:14px;line-height:150%;margin:8px 0 0 0;"], ({
  theme
}) => theme.TEXT_DEFAULT);
const TextInputErrorMessage = /*#__PURE__*/styled(TextInputDescription).withConfig({
  displayName: "TextInputstyles__TextInputErrorMessage",
  componentId: "sc-1muz39w-4"
})(["color:", ";"], ({
  theme
}) => theme.FEEDBACK_ERROR);

const determineInputAndIconContainerBorder = defaultValue => props => {
  if (props.disabled) return `2px solid ${props.theme.BACKGROUND_INPUT}`;else return determineInputBorder(defaultValue)(props);
};

const InputAndIconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "TextInputstyles__InputAndIconContainer",
  componentId: "sc-1muz39w-5"
})(["display:flex;border:", ";border-radius:8px;&:focus-within{border:", ";}"], ({
  theme
}) => determineInputAndIconContainerBorder(theme.BORDER), ({
  theme
}) => determineInputAndIconContainerBorder(theme.BORDER));
const iconBase = /*#__PURE__*/css(["align-items:center;background-color:", ";color:", ";border-radius:0 6px 6px 0;border:none;color:", ";display:flex;justify-content:center;padding:0;width:48px;border-radius:12px;:focus{outline:3px solid ", ";outline-offset:-8px;}"], ({
  theme
}) => theme.BACKGROUND_INPUT, ({
  theme
}) => theme.BACKGROUND_INPUT, ({
  theme
}) => theme.TEXT_DEFAULT, ({
  theme
}) => theme.BORDER_PRIMARY_FOCUS);
const InputIcon = /*#__PURE__*/styled.span.withConfig({
  displayName: "TextInputstyles__InputIcon",
  componentId: "sc-1muz39w-6"
})(["", ";cursor:default;& > svg{height:24px;width:24px;}"], iconBase);
const InputButtonIcon = /*#__PURE__*/styled.button.withConfig({
  displayName: "TextInputstyles__InputButtonIcon",
  componentId: "sc-1muz39w-7"
})(["", ";cursor:pointer;& > svg{height:24px;width:24px;}"], iconBase);

const validateType = type => {
  if (!['text', 'email', 'password', 'number'].includes(type)) {
    console.error(`Text input only supports prop type = 'text' | 'email' | 'password' | 'number', received ${type}. Using 'text' as default.`);
    return 'text';
  }

  return type;
};

const Icon = icon => {
  if (icon.onClick) {
    return jsx(InputButtonIcon, Object.assign({
      onClick: icon.onClick,
      "aria-label": icon.ariaLabel,
      type: "button"
    }, {
      children: jsx(icon.componentFn, {})
    }));
  }

  return jsx(InputIcon, {
    children: jsx(icon.componentFn, {
      "aria-label": icon.ariaLabel
    })
  });
};
/**
 * A generic input component with a label and optional error and description messages.
 * extra params are passed to the underlying input component as-is, except for `aria-disabled`, which
 * is controlled by `isDisabled` and `aria-labelled-by`, which is generated from `id`. Note that
 * the `props.icon.componentFn` is a function, not a component argument, i.e. `componentFn: Eye` instead of `componentFn: <Eye />`.
 *
 * @param {TextInputProps} props
 * @param {Object} props.icon
 * @param {Function} props.icon.componentFn - A render function of a component, instead of an already rendered component,
 *   i.e. `componentFn: Eye` instead of `componentFn: <Eye />`.
 * */


const TextInput = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
    label,
    id,
    value,
    onChange,
    placeholder,
    description,
    icon,
    errorMessage,
    autocomplete,
    type = 'text',
    success = false,
    isDisabled = false
  } = _a,
      other = __rest(_a, ["label", "id", "value", "onChange", "placeholder", "description", "icon", "errorMessage", "autocomplete", "type", "success", "isDisabled"]);

  const extraProps = __rest(other, ['aria-labelledby', 'aria-disabled']);

  const StyledInput = jsx(StyledTextInput, Object.assign({
    id: id,
    ref: ref,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    error: Boolean(errorMessage),
    autoComplete: autocomplete,
    type: validateType(type),
    success: !errorMessage && success,
    disabled: isDisabled,
    "aria-disabled": isDisabled,
    "aria-labelledby": `${id}-label`,
    hasIcon: Boolean(icon)
  }, extraProps));

  return jsxs(TextInputFieldset, {
    children: [jsx(TextInputLabel, Object.assign({
      htmlFor: id,
      id: `${id}-label`,
      isDisabled: isDisabled
    }, {
      children: label
    })), icon ? jsxs(InputAndIconContainer, Object.assign({
      disabled: isDisabled,
      success: !errorMessage && success,
      error: Boolean(errorMessage)
    }, {
      children: [StyledInput, jsx(Icon, {
        componentFn: icon.componentFn,
        ariaLabel: icon.ariaLabel,
        onClick: icon.onClick
      })]
    })) : StyledInput, Boolean(errorMessage) && jsx(TextInputErrorMessage, {
      children: errorMessage
    }), Boolean(description) && jsx(TextInputDescription, {
      children: description
    })]
  });
});

const TextareaFieldset = /*#__PURE__*/styled.fieldset.withConfig({
  displayName: "Textareastyles__TextareaFieldset",
  componentId: "sc-v657vo-0"
})(["border:none;margin:0;padding:0;"]);

const determineBorderColor = defaultValue => props => {
  if (props.error) {
    return props.theme.FEEDBACK_ERROR;
  } else if (props.success) {
    return props.theme.FEEDBACK_SUCCESS;
  } else {
    return defaultValue;
  }
};

const StyledTextarea = /*#__PURE__*/styled.textarea.withConfig({
  displayName: "Textareastyles__StyledTextarea",
  componentId: "sc-v657vo-1"
})(["align-items:center;background-color:", ";border:2px solid ", ";border-radius:8px;color:", ";font-family:'Open Sans',sans-serif;font-size:16px;text-decoration:none;display:flex;flex-direction:row;outline:none;padding:16px;width:100%;resize:none;scrollbar-color:", ";&:focus,&:active{outline:", ";outline-offset:2px;}&:disabled{color:", ";border:2px solid transparent;cursor:default;}&::placeholder{color:", ";}&:disabled:focus,&:disabled:active{color:", ";box-shadow:none;background-color:", ";}&:disabled::placeholder{color:", ";}::-webkit-scrollbar{background-color:transparent;width:8px;}::-webkit-scrollbar-thumb{border-radius:4px;background-color:", ";}"], props => props.theme.BACKGROUND_INPUT, props => determineBorderColor(props.theme.BORDER), props => props.theme.TEXT_DEFAULT, props => `${props.theme.BACKGROUND_CONTROL} transparent`, ({
  theme
}) => `3px solid ${theme.BORDER_PRIMARY_FOCUS}`, props => props.theme.TEXT_DISABLED, props => props.theme.TEXT_INPUT_PLACEHOLDER, props => props.theme.TEXT_DISABLED, props => props.theme.BACKGROUND_INPUT, props => props.theme.TEXT_DISABLED, props => props.theme.BACKGROUND_CONTROL);
const TextareaDescription = /*#__PURE__*/styled.p.withConfig({
  displayName: "Textareastyles__TextareaDescription",
  componentId: "sc-v657vo-2"
})(["color:", ";font-family:'Open Sans',sans-serif;text-decoration:none;font-size:14px;line-height:150%;margin:8px 0 0 0;"], props => props.theme.TEXT_DEFAULT);
const TextareaErrorMessage = /*#__PURE__*/styled(TextareaDescription).withConfig({
  displayName: "Textareastyles__TextareaErrorMessage",
  componentId: "sc-v657vo-3"
})(["color:", ";"], props => props.theme.FEEDBACK_ERROR);

/**
 * A textarea component with a label and optional error and description messages.
 * extra params are passed to the underlying textarea component as-is, except for `aria-disabled`, which
 * is controlled by `isDisabled` and `aria-labelled-by`, which is generated from `id`.
 *
 * @param {TextareaProps} props
 * */

const Textarea = /*#__PURE__*/React__default.forwardRef((_a, ref) => {
  var {
    label,
    id,
    value,
    onChange,
    placeholder,
    rows,
    description,
    errorMessage,
    success = false,
    isDisabled = false
  } = _a,
      other = __rest(_a, ["label", "id", "value", "onChange", "placeholder", "rows", "description", "errorMessage", "success", "isDisabled"]);

  const extraProps = __rest(other, ['aria-labelledby', 'aria-disabled']);

  return jsxs(TextareaFieldset, {
    children: [jsx(FormElementLabel, Object.assign({
      htmlFor: id,
      id: `${id}-label`,
      isDisabled: isDisabled
    }, {
      children: label
    })), jsx(StyledTextarea, Object.assign({
      id: id,
      ref: ref,
      value: value,
      onChange: onChange,
      placeholder: placeholder,
      rows: rows,
      error: Boolean(errorMessage),
      success: !errorMessage && success,
      disabled: isDisabled,
      "aria-disabled": isDisabled,
      "aria-labelledby": `${id}-label`
    }, extraProps)), Boolean(errorMessage) && jsx(TextareaErrorMessage, {
      children: errorMessage
    }), Boolean(description) && jsx(TextareaDescription, {
      children: description
    })]
  });
});

const Message = /*#__PURE__*/styled.p.withConfig({
  displayName: "Message",
  componentId: "sc-1k4ovao-0"
})(({
  theme,
  error
}) => ({
  color: error ? theme.FEEDBACK_ERROR : theme.TEXT_DEFAULT,
  fontFamily: "'Open Sans', sans-serif",
  textDecoration: 'none',
  fontSize: 14,
  lineHeight: 1.5,
  margin: '8px 0 0 0'
}));

const StyledFieldset = /*#__PURE__*/styled.fieldset.withConfig({
  displayName: "RadioGroupsstyles__StyledFieldset",
  componentId: "sc-q6nn9g-0"
})({
  border: 0,
  padding: 0,
  margin: 0
});
const StyledRadioGroup = /*#__PURE__*/styled.div.withConfig({
  displayName: "RadioGroupsstyles__StyledRadioGroup",
  componentId: "sc-q6nn9g-1"
})({
  display: 'flex',
  flexDirection: 'column',
  '& > label:not(:last-child)': {
    marginBottom: 8
  },
  [`&:not(:only-child)`]: {
    marginTop: 8
  }
});
const StyledLabel = /*#__PURE__*/styled.legend.withConfig({
  displayName: "RadioGroupsstyles__StyledLabel",
  componentId: "sc-q6nn9g-2"
})(({
  theme
}) => ({
  color: theme.TEXT_DEFAULT,
  marginBottom: 8,
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1.5,
  margin: 0
}));
const StyledDescription = /*#__PURE__*/styled.div.withConfig({
  displayName: "RadioGroupsstyles__StyledDescription",
  componentId: "sc-q6nn9g-3"
})(({
  theme
}) => ({
  color: theme.TEXT_DEFAULT,
  fontSize: 14,
  lineHeight: 1.5
}));

const RadioGroup = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    name,
    selectedValue: valueProp,
    id: idProp,
    errorMessage,
    label,
    description,
    onChange
  } = props,
        rest = __rest(props, ["children", "name", "selectedValue", "id", "errorMessage", "label", "description", "onChange"]);

  const [value, setValueState] = useState(valueProp);
  const useFieldset = label || description;
  const hasError = Boolean(errorMessage);
  const id = idProp || `group-${name}`;
  useEffect(() => {
    setValueState(valueProp);
  }, [valueProp]);

  const handleChange = event => {
    setValueState(event.target.value);

    if (onChange) {
      onChange(event);
    }
  };

  const renderRadioGroup = () => jsx(StyledRadioGroup, Object.assign({
    role: "radiogroup",
    "aria-label": label,
    ref: ref
  }, {
    children: children
  }));

  return jsx(RadioGroupContext.Provider, Object.assign({
    value: {
      name,
      onChange: handleChange,
      value,
      error: hasError,
      errorId: hasError ? `${id}-error` : undefined,
      descId: description ? `${id}-desc` : undefined
    }
  }, {
    children: useFieldset ? jsxs(StyledFieldset, Object.assign({}, rest, {
      children: [label && jsx(StyledLabel, {
        children: label
      }), description && jsx(StyledDescription, Object.assign({
        id: `${id}-desc`
      }, {
        children: description
      })), renderRadioGroup(), hasError && jsx(Message, Object.assign({
        id: `${id}-error`,
        error: true
      }, {
        children: errorMessage
      }))]
    })) : jsxs(Fragment, {
      children: [renderRadioGroup(), hasError && jsx(Message, Object.assign({
        id: `${id}-error`,
        error: true
      }, {
        children: errorMessage
      }))]
    })
  }));
});

const ThemeContext = /*#__PURE__*/React__default.createContext({
  unit: 'rem',
  baseUnit: 16
});

const YdsThemeProvider = ({
  theme: themeProp = 'light',
  unit: _unit = 'rem',
  baseUnit: _baseUnit = 16,
  children
}) => {
  const usingPresetTheme = typeof themeProp === 'string';
  const theme = usingPresetTheme ? themeProp === 'dark' ? darkTheme : lightTheme : themeProp;
  return jsx(ThemeContext.Provider, Object.assign({
    value: {
      unit: _unit,
      baseUnit: _baseUnit
    }
  }, {
    children: jsx(ThemeProvider, Object.assign({
      theme: theme
    }, {
      children: children
    }))
  }));
};

export { ActionMenu, Button, Checkbox, ChoiceButton, DropdownMenu, FormElementLabel, MenuItem, Notification, Radio, RadioGroup, Select, Switch, Tag, TextInput, Textarea, YdsThemeProvider };
